import { StoreStockData } from 'common/components/stocks-in-stores/types';

type Args = {
  isBot: boolean;
  enabled: boolean;
  stocks: StoreStockData[];
  isStocksLoading: boolean;
  isSet?: boolean;
  price?: number | null;
  maxPriceThreshold?: number;
  KindDivisionsList: string[];
  currentDivision: string;
  KindSourceList: string[];
  currentSource?: string;
};

export const getVisibilityBanner = ({
  isBot,
  enabled,
  stocks,
  isStocksLoading,
  isSet,
  price,
  maxPriceThreshold,
  KindDivisionsList,
  currentDivision,
  KindSourceList,
  currentSource,
}: Args) => {
  if (isBot || !enabled) return false;
  if (!stocks.length && !isStocksLoading && !isSet) return false;
  if (price && maxPriceThreshold && price > maxPriceThreshold) return false;

  const isExcludedDivision = KindDivisionsList.some((d) => String(d) === currentDivision);
  const isExcludedSource = KindSourceList.some((s) => s.toLowerCase() === currentSource);
  if (isExcludedDivision || isExcludedSource) return false;

  return true;
};
